import CoreBase from '../../services/engines/CoreBase';
import userStateService from '../../services/UserStateService';
import responseHelper from '../../services/ResponseHelper';

const _name = 'UserStateFetcher';

class UserStateFetcher extends CoreBase {
    fetch = async () => {
        try {
            const resp = await userStateService.getUserState2();
            const code = responseHelper.check(resp, 'getUserState2', _name);
            if (code !== 200) return null;

            return resp.data.items ?? [];
        } catch (error) {
            this.logError('fetch', error.message);
            return null;
        }
    };
}

const userStateFetcher = new UserStateFetcher();
export default userStateFetcher;
